import gsap from "gsap";

//////////////////////////////////////////////////////
// GSAP animations for event pages
//////////////////////////////////////////////////////

function eventAniFunc() {
  const tl = new gsap.timeline();

  tl.fromTo(
    ".event-headings > .top-heading",
    {
      opacity: 0,
      x: -200,
    },
    {
      opacity: 1,
      x: 0,
      duration: 0.5,
    }
  )
    .fromTo(
      ".event-headings > .sub-heading",
      {
        opacity: 0,
        x: -200,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.5,
      }
    )
    .fromTo(
      ".countdown-timer > .countdown-timer__block-small",
      {
        opacity: 0,
        y: 200,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.1,
      }
    )
    .fromTo(
      ".event-headings > .btn",
      {
        opacity: 0,
        y: 50,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
      },
      ">-0.3"
    );
}

// exports function to be used on other scripts
export default eventAniFunc;
